import template from './positionsPanel.html';
import controller from './positionsPanel.controller';

let component = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    staffUser: '<',
    positions: '<',
    title: '@',
    showAddAdhocButton: '<',
    collapsed: '<',
    onToggleCollapsed: '&',
  }
};

export default component;
